export default __webpack_public_path__ + "static/media/icon_list.de53a37e.svg";